module.exports = __webpack_public_path__ + "674f50d287a8c48dc19ba404d20fe713.eot";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/fontawesome-webfont.eot?v=4.7.0
// module id = 1493
// module chunks = 0